import { ZepQuizApiError } from '@/api/httpClient';
import { openFlexibleDialog } from '@/ui_v3/components/dialog/FlexibleDialog';

/**
 *  @use
 *  showMappedApiErrorDialog(error, {
 *  서버지정 타입: {
 *    title: '타이틀',
 *    onConfirm: () => {
 *      // 모달 확인 후 실행
 *    },
 *    onTriggerImmediately: () => {
 *      // status 가 매칭되자마자 실행
 *    },
 *  },
 *  },
 * */
export const showMappedApiErrorDialog = <API_STATUS extends string>(
  error: unknown,
  bindings: Record<API_STATUS, ApiErrorBinding>,
  fallback: ApiErrorBinding & { showServerMessage: boolean } = {
    title: '',
    message: '',
    showServerMessage: false,
    onConfirm: () => {},
  },
): void => {
  if (!(error instanceof ZepQuizApiError)) {
    console.warn(error, 'unknown error');
    void openFlexibleDialog({
      body: 'unknown Error',
      footerButtons: [
        {
          kind: 'confirm',
          intent: 'strong',
        },
      ],
    });
    return;
  }

  const binding = bindings[error.status as API_STATUS];
  if (!binding) {
    if (fallback.title) {
      void openFlexibleDialog({
        header: { title: fallback.title },
        body: fallback.showServerMessage ? error.message : fallback.message,
        hasDim: true,
        shouldCloseOnDimClick: false,
        footerButtons: [
          {
            kind: 'confirm',
            intent: 'strong',
          },
        ],
      }).then(() => fallback.onConfirm?.());
    }
    return;
  }

  // 즉시 실행이 필요한 핸들러가 있다면 여기서 실행
  binding.onTriggerImmediately?.();

  void openFlexibleDialog({
    header: { title: binding.title },
    body: binding.message,
    footerButtons: [
      {
        kind: 'confirm',
        intent: 'strong',
      },
    ],
  }).then(() => binding.onConfirm?.());
};
type ApiErrorBinding = {
  title: string;
  message?: string;
  onConfirm: () => void;
  onTriggerImmediately?: () => void;
};
